import { Chip, ChipProps } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import { STATUS_LABEL, StatusType } from 'constants/enums/status';

interface Props extends ChipProps {
  status: string;
}

const StatusChip = (props: Props) => {
  const { status, ...chipProps } = props;
  const theme = useTheme();
  const { palette } = theme;

  // Normalize status to lowercase/underscores to match keys
  const normalized = (status || '').toLowerCase().replace(/\s+/g, '_') as StatusType;

  // Safely extract custom palette values or fall back
  const branchLighterRaw = (palette as any).branchLighter;
  const branchLighter =
    typeof branchLighterRaw === 'string' ? branchLighterRaw : branchLighterRaw?.main || palette.grey[300];

  // Background color mapping
  const bgColorMap: Record<StatusType, string> = {
    incomplete: palette.warning.main,
    recorded: palette.primary.main,
    confirmed: palette.success.main,
    completed: palette.success.main,
    inprogress: palette.primary.main,
    fixed: branchLighter,
    on_route: '#00FFFF',
    arrived: palette.success.main,
    complete: palette.success.main,
    cancelled: '#FEF2F2',
    unknown: '#D9D9D9',
    delivered: '#ECFDF5',
    open: '#EFF6FF',
    undefined: '#D9D9D9',
    invoiced: '#4caf50',
    received: palette.success.main,
    not_done: palette.warning.main,
    partial: palette.info.main,
  };

  // Text color mapping for specific statuses
  const textColorMap: Partial<Record<StatusType, string>> = {
    cancelled: '#DC2626',
    delivered: '#059669',
    open: '#2563EB',
  };

  // Determine colors (fallback to theme getContrastText)
  const bgColor = bgColorMap[normalized] || palette.grey[500];
  const label = STATUS_LABEL[normalized] || status;
  const textColor =
    textColorMap[normalized] ||
    (typeof bgColor === 'string' && palette.getContrastText ? palette.getContrastText(bgColor) : palette.text.primary);

  return (
    <Chip
      label={label}
      variant="filled"
      sx={{
        backgroundColor: bgColor,
        color: textColor,
        fontWeight: 500,
        fontSize: '0.875rem',
        padding: '0.375rem 0.75rem',
        borderRadius: '0.5rem',
      }}
      {...chipProps}
    />
  );
};

export default StatusChip;
